/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable prettier/prettier */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { createRoot } from "react-dom/client";

let warningTimeout;
let logoutTimeout;
let popupRoot;
let popupContainer;

// --- hide popup ---
const hidePopup = () => {
  if (popupRoot) {
    popupRoot.unmount();
    popupRoot = null;
  }
  if (popupContainer && popupContainer.parentNode) {
    popupContainer.parentNode.removeChild(popupContainer);
    popupContainer = null;
  }
};

// --- show popup ---
const showSessionPopup = (onLogout, onExtend) => {
  if (popupRoot) return;

  popupContainer = document.createElement("div");
  document.body.appendChild(popupContainer);
  popupRoot = createRoot(popupContainer);

  const countdown = 60; // seconds

  function Popup() {
    const [timeLeft, setTimeLeft] = React.useState(countdown);

    React.useEffect(() => {
      const countdownInterval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            onLogout();
            hidePopup();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }, []);

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "20px 30px",
            textAlign: "center",
            width: "350px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <h3>Your session is about to expire.</h3>
          <p>Would you like to continue working?</p>
          <p
            style={{ marginTop: "10px", fontWeight: "bold", color: "#c0392b" }}
          >
            Auto logout in {timeLeft}s
          </p>
          <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
            <button
              type="button"
              onClick={() => {
                onLogout();
                hidePopup();
              }}
              style={{
                background: "#e74c3c",
                color: "#fff",
                border: "none",
                padding: "8px 14px",
                borderRadius: "5px",
                flex: 1,
                cursor: "pointer",
              }}
            >
              No, I'm not working
            </button>

            <button
              type="button"
              onClick={() => {
                hidePopup();
                onExtend();
              }}
              style={{
                background: "#27ae60",
                color: "#fff",
                border: "none",
                padding: "8px 14px",
                borderRadius: "5px",
                flex: 1,
                cursor: "pointer",
              }}
            >
              Yes, I'm working ({timeLeft})
            </button>
          </div>
        </div>
      </div>
    );
  }

  popupRoot.render(<Popup />);
};

// --- user activity tracking ---
const activityEvents = [
  "click",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
];

let resetTimerCallback;

const attachActivityListeners = (onLogout, onExtend) => {
  resetTimerCallback = (event) => {
    // console.log(
    //   `User activity detected: ${
    //     event.type
    //   } at ${new Date().toLocaleTimeString()}`
    // );
    // console.log("Current URL:", window.location.href);
    // console.log("Current Path:", window.location.pathname);
    // Timer reset
    // eslint-disable-next-line no-use-before-define
    resetTimer(onLogout, onExtend);
  };

  activityEvents.forEach((eventName) =>
    document.addEventListener(eventName, resetTimerCallback),
  );
};

const removeActivityListeners = () => {
  if (resetTimerCallback) {
    activityEvents.forEach((event) =>
      document.removeEventListener(event, resetTimerCallback),
    );
  }
};

// --- reset timers on activity ---
const resetTimer = (onLogout, onExtend) => {
  clearTimeout(warningTimeout);
  clearTimeout(logoutTimeout);

  // 2 min inactivity → show popup
  warningTimeout = setTimeout(
    () => {
      showSessionPopup(onLogout, onExtend);
    },
    29 * 60 * 1000,
  ); // 2 minutes

  // 3 min inactivity → auto logout
  logoutTimeout = setTimeout(
    () => {
      onLogout();
      hidePopup();
    },
    30 * 60 * 1000,
  ); // 3 minutes
};

// --- start session timer ---
export const startSessionTimer = (onLogout, onExtend) => {
  resetTimer(onLogout, onExtend);
  removeActivityListeners();
  attachActivityListeners(onLogout, onExtend);
};

// --- clear session timer ---
export const clearSessionTimer = () => {
  clearTimeout(warningTimeout);
  clearTimeout(logoutTimeout);
  hidePopup();
  removeActivityListeners();
};
